import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable()
export abstract class BaseStorageService {
  constructor(readonly url: string) {}
  readonly http = inject(HttpClient);

  load<T>(key: string) {
    return this.http.get<T>(`${this.url}/${key}`);
  }

  save<T, U = T>(key: string, data: T) {
    return this.http.post<U>(`${this.url}/${key}`, data);
  }

  delete(key: string) {
    return this.http.delete(`${this.url}/${key}`);
  }
}
